import React from 'react';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
const CMP = (props: Partial<CustomIconComponentProps>) => (
  <svg viewBox="0 0 27 27" {...props}>
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="编组-27">
        <circle id="椭圆形" fill-opacity="0.2" fill="#999999" fill-rule="nonzero" cx="13.5" cy="13.5" r="13.5"></circle>
        <g id="编组-10" stroke-linecap="round" transform="translate(9.5, 9.4545)" stroke="#000000">
          <line x1="0" y1="1.11022302e-16" x2="9" y2="9.0909091" id="直线"></line>
          <line
            x1="0"
            y1="1.11022302e-16"
            x2="9"
            y2="9.0909091"
            id="直线备份"
            transform="translate(4.5, 4.5455) scale(-1, 1) translate(-4.5, -4.5455)"
          ></line>
        </g>
      </g>
    </g>
  </svg>
);

export default CMP;
